//returns the sound object
export default function getSound(key) {
  return [{ key: key, type: "sound" }];
}
